// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"4cd227d0","885":"411e8e18"}[chunkId] + ".chunk.js";
};